import { Component, OnInit, Input } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { AppConfigService } from 'app/services/app-config/app-config.service';

@Component({
  selector: 'act-dialog-see-all-properties',
  templateUrl: './dialog-see-all-properties.component.html',
  styleUrls: ['./dialog-see-all-properties.component.scss']
})
export class DialogSeeAllPropertiesComponent implements OnInit {
  
  @Input() isCustomText = false;
  @Input() text: string;
  
  constructor(
    private dialogRef: MdDialogRef<DialogSeeAllPropertiesComponent>,
    private appConfigService: AppConfigService
  ) { }

  ngOnInit() {
  }

  lang() {
    return this.appConfigService.getLanguage();
  }

  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-see-all-properties/dialog-see-all-properties.component.ts